/** Privacy Policy. The text is client/public/privacy.html; see StaticLegalPage. */
import StaticLegalPage from './StaticLegalPage';

export default function PrivacyPolicy() {
  return <StaticLegalPage doc="privacy" />;
}
